// extracted by mini-css-extract-plugin
export default {"form":"ViewPedidoBmaFolha_form__99sbp","areaBtn":"ViewPedidoBmaFolha_areaBtn__+kMAV","btn":"ViewPedidoBmaFolha_btn__RR7aC","btn2":"ViewPedidoBmaFolha_btn2__f3rzp"};